import { RESET_ALL, SET_CARD_LIST } from "redux/types";

const defaultCardList = {
  cardListDetail: [],
  totalArchive: 0,
};

const cardListReducer = (state = defaultCardList, action) => {
  switch (action.type) {
    case SET_CARD_LIST:
      return {
        ...state,
        ...action.payload,
      };
    case RESET_ALL:
      return defaultCardList;
    default:
      return state;
  }
};

export default cardListReducer;
